module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v("News")])])], 1)], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : [(_vm.$breakpoints.xs) ? [_c('sk-accordian', [_c('template', {
    slot: "header"
  }, [_c('h4', [_vm._v("All")])]), _vm._v(" "), _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "panel"
  }, _vm._l((_vm.newsItems), function(news, index) {
    return ((news.general.type == _vm.newsFilter || _vm.newsFilter == 'All')) ? _c('div', {
      key: news.general.id
    }, [(index != 0) ? _c('sk-divider') : _vm._e(), _vm._v(" "), _c('sk-layout', {
      staticClass: "article article--summary",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "md3": ""
      }
    }, [_c('div', {
      staticClass: "article__image"
    }, [(news.general.type == 'Genres') ? [_c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": ("/news/genres/detail/" + (news.general.id) + "/" + (news.general.slug))
      }
    }, [_c('img', {
      attrs: {
        "alt": news.top_section.image.alt ? news.top_section.image.alt : '',
        "src": news.top_section.image ? news.top_section.image.url : '/static/img/news-placeholder.jpg'
      }
    })])] : (news.general.type == 'Blogs') ? [_c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": ("/news/blogs/detail/" + (news.general.id) + "/" + (news.general.slug))
      }
    }, [_c('img', {
      attrs: {
        "alt": news.top_section.image.alt ? news.top_section.image.alt : '',
        "src": news.top_section.image ? news.top_section.image.url : '/static/img/news-placeholder.jpg'
      }
    })])] : [_c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": ("/news/detail/" + (news.general.id) + "/" + (news.general.slug))
      }
    }, [_c('img', {
      attrs: {
        "alt": news.top_section.image.alt ? news.top_section.image.alt : '',
        "src": news.top_section.image ? news.top_section.image.url : '/static/img/news-placeholder.jpg'
      }
    })])]], 2)]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "md9": ""
      }
    }, [_c('h6', [(news.general.type == 'Genres') ? [_c('sk-button', {
      staticClass: "article__title",
      attrs: {
        "tag": "a",
        "href": ("/news/genres/detail/" + (news.general.id) + "/" + (news.general.slug))
      },
      domProps: {
        "innerHTML": _vm._s(news.general.title)
      }
    })] : (news.general.type == 'Blogs') ? [_c('sk-button', {
      staticClass: "article__title",
      attrs: {
        "tag": "a",
        "href": ("/news/blogs/detail/" + (news.general.id) + "/" + (news.general.slug))
      },
      domProps: {
        "innerHTML": _vm._s(news.general.title)
      }
    })] : [_c('sk-button', {
      staticClass: "article__title",
      attrs: {
        "tag": "a",
        "href": ("/news/detail/" + (news.general.id) + "/" + (news.general.slug))
      },
      domProps: {
        "innerHTML": _vm._s(news.general.title)
      }
    })]], 2), _vm._v(" "), _c('span', {
      staticClass: "article__author",
      domProps: {
        "innerHTML": _vm._s(news.general.author)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "article__date"
    }, [_vm._v(_vm._s(news.general.date))]), _vm._v(" "), _c('div', {
      staticClass: "article__summary"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s((news.top_section.summary))
      }
    }), _vm._v(" "), (news.general.type == 'Genres') ? [_c('sk-button', {
      attrs: {
        "link": "",
        "small": "",
        "tag": "a",
        "href": ("/news/genres/detail/" + (news.general.id) + "/" + (news.general.slug))
      }
    }, [_vm._v(" Read more")])] : (news.general.type == 'Blogs') ? [_c('sk-button', {
      attrs: {
        "link": "",
        "small": "",
        "tag": "a",
        "href": ("/news/blogs/detail/" + (news.general.id) + "/" + (news.general.slug))
      }
    }, [_vm._v(" Read more")])] : [_c('sk-button', {
      attrs: {
        "link": "",
        "small": "",
        "tag": "a",
        "href": ("/news/detail/" + (news.general.id) + "/" + (news.general.slug))
      }
    }, [_vm._v(" Read more")])]], 2)])], 1)], 1) : _vm._e()
  }))])], 2)] : [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-tabs', {
    attrs: {
      "size": 4
    }
  }, [_c('template', {
    slot: "tab-title"
  }, [_c('sk-tab', {
    class: {
      active: _vm.newsFilter == 'All'
    },
    attrs: {
      "item": "All"
    },
    nativeOn: {
      "click": function($event) {
        _vm.newsFilter = 'All'
      }
    }
  }), _vm._v(" "), _c('sk-tab', {
    class: {
      active: _vm.newsFilter == 'Corporate'
    },
    attrs: {
      "item": "Corporate"
    },
    nativeOn: {
      "click": function($event) {
        _vm.newsFilter = 'Corporate'
      }
    }
  }), _vm._v(" "), _c('sk-tab', {
    class: {
      active: _vm.newsFilter == 'Press_Release'
    },
    attrs: {
      "item": "Press Release"
    },
    nativeOn: {
      "click": function($event) {
        _vm.newsFilter = 'Press_Release'
      }
    }
  }), _vm._v(" "), _c('sk-tab', {
    class: {
      active: _vm.newsFilter == 'Business_Rescue'
    },
    attrs: {
      "item": "Business Rescue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.newsFilter = 'Business_Rescue'
      }
    }
  }), _vm._v(" "), _c('sk-tab', {
    class: {
      active: _vm.newsFilter == 'Blogs'
    },
    attrs: {
      "item": "Blogs"
    },
    nativeOn: {
      "click": function($event) {
        _vm.newsFilter = 'Blogs'
      }
    }
  }), _vm._v(" "), _c('sk-tab', {
    class: {
      active: _vm.newsFilter == 'Genres'
    },
    attrs: {
      "item": "Genres"
    },
    nativeOn: {
      "click": function($event) {
        _vm.newsFilter = 'Genres'
      }
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "tab-content"
  }, [_c('sk-panel', _vm._l((_vm.newsItems), function(news, index) {
    return ((news.general.type == _vm.newsFilter || _vm.newsFilter == 'All')) ? _c('div', {
      key: news.general.id
    }, [_c('hr'), _vm._v(" "), _c('sk-layout', {
      staticClass: "article article--summary",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "md3": ""
      }
    }, [_c('div', {
      staticClass: "article__image"
    }, [(news.general.type == 'Genres') ? [_c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: 'NewsGenresDetail',
          params: {
            nid: news.general.id,
            slug: news.general.slug
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": news.top_section.image.alt ? news.top_section.image.alt : '',
        "src": news.top_section.image ? news.top_section.image.url : '/static/img/news-placeholder.jpg'
      }
    })])] : (news.general.type == 'Blogs') ? [_c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: 'NewsBlogDetail',
          params: {
            nid: news.general.id,
            slug: news.general.slug
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": news.top_section.image.alt ? news.top_section.image.alt : '',
        "src": news.top_section.image ? news.top_section.image.url : '/static/img/news-placeholder.jpg'
      }
    })])] : [_c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: 'NewsDetail',
          params: {
            nid: news.general.id,
            slug: news.general.slug
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": news.top_section.image.alt ? news.top_section.image.alt : '',
        "src": news.top_section.image ? news.top_section.image.url : '/static/img/news-placeholder.jpg'
      }
    })])]], 2)]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "md9": ""
      }
    }, [_c('h6', [(news.general.type == 'Genres') ? [_c('sk-button', {
      staticClass: "article__title",
      attrs: {
        "flat": "",
        "router": "",
        "to": {
          name: 'NewsGenresDetail',
          params: {
            nid: news.general.id,
            slug: news.general.slug
          }
        }
      }
    }, [_vm._v(_vm._s(news.general.title))])] : (news.general.type == 'Blogs') ? [_c('sk-button', {
      staticClass: "article__title",
      attrs: {
        "flat": "",
        "router": "",
        "to": {
          name: 'NewsBlogDetail',
          params: {
            nid: news.general.id,
            slug: news.general.slug
          }
        }
      }
    }, [_vm._v(_vm._s(news.general.title))])] : [_c('sk-button', {
      staticClass: "article__title",
      attrs: {
        "flat": "",
        "router": "",
        "to": {
          name: 'NewsDetail',
          params: {
            nid: news.general.id,
            slug: news.general.slug
          }
        }
      }
    }, [_vm._v(_vm._s(news.general.title))])]], 2), _vm._v(" "), _c('span', {
      staticClass: "article__author",
      domProps: {
        "innerHTML": _vm._s(news.general.author)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "article__date"
    }, [_vm._v(_vm._s(news.general.date))]), _vm._v(" "), _c('div', {
      staticClass: "article__summary"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s((news.top_section.summary))
      }
    }), _vm._v(" "), (news.general.type == 'Genres') ? [_c('sk-button', {
      attrs: {
        "link": "",
        "small": "",
        "router": "",
        "to": {
          name: 'NewsGenresDetail',
          params: {
            nid: news.general.id,
            slug: news.general.slug
          }
        }
      }
    }, [_vm._v(" Read more")])] : (news.general.type == 'Blogs') ? [_c('sk-button', {
      attrs: {
        "link": "",
        "small": "",
        "router": "",
        "to": {
          name: 'NewsBlogDetail',
          params: {
            nid: news.general.id,
            slug: news.general.slug
          }
        }
      }
    }, [_vm._v(" Read more")])] : [_c('sk-button', {
      attrs: {
        "link": "",
        "small": "",
        "router": "",
        "to": {
          name: 'NewsDetail',
          params: {
            nid: news.general.id,
            slug: news.general.slug
          }
        }
      }
    }, [_vm._v(" Read more")])]], 2)])], 1)], 1) : _vm._e()
  }))], 1)], 2)], 1)], 1)]]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c120211","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/news/news.vue
// module id = 590
// module chunks = 0